import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { AnnounceList, delAnnounce } from "@/api/gmToolNew/gmToolNew";
import addBoradcast from "./components/addBoradcast";
import boradcastDetils from "./components/boradcastDetils.vue";
export default {
  name: "boradcast",
  components: {
    addBoradcast: addBoradcast,
    boradcastDetils: boradcastDetils
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      page: 1,
      sels: [],
      selsString: '',
      server_id: [],
      serverIdList: [],
      checked: false
    };
  },
  created: function created() {},
  methods: {
    envIdChange: function envIdChange() {
      this.serverChannel = [];
      this.server_channel = "";
      this.show_test = "";
      this.server_id = [];
      this.paramsData.server_id = "";
      this.serverListYJ = [];
      this.getannounceChannelData();
    },
    serverChange: function serverChange() {
      if (this.paramsData) {
        this.paramsData.server_id = '';
      }

      this.server_id = [];
      this.serverListYJ = [];
      this.show_test = "";
    },
    serverChannelChange: function serverChannelChange() {
      var ismessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.paramsData) {
        this.paramsData.server_id = '';
      }

      if (this.searchData) {
        this.searchData.server_id = '';
      }

      this.serverListYJ = [];
      this.server_id = [];

      if (!this.server_channel) {
        ismessage && this.$message.error(this.$t('pleaseSelectServerChannel'));
        return;
      }

      if (this.show_test === "") {
        return;
      }

      this.checked = false;
      this.getServerList();
    },
    getList: function getList(e) {
      var _this = this;

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.reqLoading = true;
      this.paramsData.page = e;
      AnnounceList(this.paramsData).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleSource: function handleSource(id) {
      this.$refs.addBoradcast.init(id);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDelete: function handleDelete(ids, serverId) {
      var _this3 = this;

      var id = ids.toString();
      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delAnnounce({
                  id: id,
                  server_id: serverId,
                  env_id: _this3.paramsData.env_id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.getList(_this3.paramsData.page);
                  }
                });

                _this3.$message({
                  type: "success",
                  message: _this3.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};